import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const getCoins = createAsyncThunk("coin/getCoins", async (get) => {
  const response = await get("/webapp/profile/");
  return response.credits;
});

const coinSlice = createSlice({
  name: "coin",
  initialState: {
    amount: 0,
    status: "idle",
    error: null,
  },
  reducers: {
    spendCoin: (state, action) => {
      state.amount -= action.payload;
    },
    addCoin: (state, action) => {
      state.amount += action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCoins.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCoins.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.amount = action.payload;
      })
      .addCase(getCoins.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { spendCoin, addCoin } = coinSlice.actions;
export default coinSlice.reducer;
